import { AppContext } from '../../contexts/app-context';
import React, { useContext, useEffect, useRef, useState } from 'react';

const RedEye = () => {

    const { page, productData } = useContext(AppContext);

    const [wrapperPrice] = useState(productData?.price?.monthlyPriceFormatted);
    const [annualPrice] = useState(productData?.price?.yearlyPriceFormatted);
    const [excessPrice] = useState(productData?.price?.excessPriceFormatted);
    const [quarterPrice] = useState(productData?.price?.quarterlyPrice);
    const [consentCheck, setConsentCheck] = useState('');

    const node = useRef();

    const handleClick = (event) => {
        if (!node?.current?.contains(event.target)) {
            setConsentCheck('red eye');
        }
    };

    useEffect(() => {
        window.addEventListener('click', handleClick);
    }, []);
    let redeyeurl = '';
    const pageUrl = typeof (document) !== 'undefined' ? encodeURIComponent(Window && window.location.href) : '';

    if ((typeof Cookiebot !== 'undefined' && window?.Cookiebot?.consent?.marketing === true) || consentCheck === 'red eye') {
        if (page === 'comparison') {
            redeyeurl = `view_nourl=${pageUrl}&nourl=${pageUrl}&view_product=combined%20comparison&view_event=yes`;
        } else if (page === 'product') {
            const title = encodeURIComponent(productData?.name);
            redeyeurl = `nourl=${pageUrl}&quote_event=yes&quote_url=${pageUrl}&quote_product=${title}&quote_desc=${title}&quote_image=&quote_val=${wrapperPrice}&quote_quarterly_val=${quarterPrice}&quote_annual_val=${annualPrice}&quote_effective_cost=&quote_excess=${excessPrice}")`;
        } else {
            redeyeurl = `nourl=${pageUrl}`;
        }

        return (
            <>
                <img id="redeyetracking" src={`//reporting.homeserve.com/cgi-bin/rr/blank.gif?${redeyeurl}`} style={{ display: 'none' }} ref={node} />
            </>
        );
    } else {
        return (<div><h4 style={{ display: 'none' }}>'Marketing Denied'</h4></div>);
    }
};
export default RedEye;
